import {
  Box,
  Button,
  HStack,
  Stack,
  Text,
  type StackProps,
} from '@chakra-ui/react';
import { type FC, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledLink } from '$/components/core/StyledLink';

interface Props extends StackProps {
  headline: string;
  showAllUrl?: string;
  onShowMoreClick?: () => void;
  children: ReactNode;
  customActionElement?: ReactNode;
}

export const SectionHeadline: FC<Props> = ({
  showAllUrl,
  onShowMoreClick,
  headline,
  children,
  customActionElement,
  ...props
}) => {
  const { t } = useTranslation();

  const generalShowMoreProps = {
    px: '0',
    color: 'lighterText',
    fontSize: 'sm',
    borderRadius: '4',
    _hover: { bg: 'bodyBackground' },
  };

  return (
    <Stack alignItems='flex-start' gap='3' w='full' {...props}>
      <HStack
        justify='space-between'
        flexWrap='wrap'
        w='full'
        fontWeight='bold'
      >
        <Text pr='8' fontSize='lg'>
          {headline}
        </Text>
        {showAllUrl && (
          <StyledLink to={showAllUrl} {...generalShowMoreProps}>
            {t('dashboard.welcome.showAllButton')}
          </StyledLink>
        )}
        {onShowMoreClick && (
          <Button
            h='fit-content'
            py='1'
            onClick={onShowMoreClick}
            variant='ghost'
            {...generalShowMoreProps}
          >
            {t('dashboard.welcome.showAllButton')}
          </Button>
        )}
        {customActionElement}
      </HStack>
      <Box w='full'>{children}</Box>
    </Stack>
  );
};
